module.exports = __webpack_public_path__ + "img/banner-principal.4228ff88.png";